import { __ } from '@wordpress/i18n'

export default {
  subtitle: __('ANWENDUNG', 'dhsv_theme'),
}
